import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Avatar from './Avatar';

const Layout = () => {
  const { user, logout, myPhoto } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="brand">
          City of Preston Basketball
          <small>Preston Basketball CIC — Coach Portal</small>
        </div>
        <nav>
          {/* Somebody still on a password an admin chose for them gets one link
              and one job. The routes already redirect them (see App.js), so
              leaving the full menu drawn would only give them six tabs that all
              bounce back to the same form. */}
          {user.must_change_password ? (
            <NavLink to="/profile" className={({ isActive }) => isActive ? 'active' : ''}>
              {user.role === 'admin' ? 'My account' : 'My profile'}
            </NavLink>
          ) : user.role === 'admin' ? (
            <>
              <NavLink to="/submissions" className={({ isActive }) => isActive ? 'active' : ''}>Submissions</NavLink>
              <NavLink to="/bills" className={({ isActive }) => isActive ? 'active' : ''}>Bills</NavLink>
              <NavLink to="/coaches" className={({ isActive }) => isActive ? 'active' : ''}>Coaches</NavLink>
              <NavLink to="/venues" className={({ isActive }) => isActive ? 'active' : ''}>Venues</NavLink>
              <NavLink to="/teams" className={({ isActive }) => isActive ? 'active' : ''}>Sessions</NavLink>
              <NavLink to="/fixtures" className={({ isActive }) => isActive ? 'active' : ''}>Fixtures</NavLink>
              {/* Same page as a coach's "My profile", same route. An admin has
                  no photo on it, so it is only their details and the
                  change-password form, and "My account" is the honest name
                  for that. */}
              <NavLink to="/profile" className={({ isActive }) => isActive ? 'active' : ''}>My account</NavLink>
            </>
          ) : (
            <>
              <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>My hours</NavLink>
              <NavLink to="/profile" className={({ isActive }) => isActive ? 'active' : ''}>My profile</NavLink>
            </>
          )}
          {/* A coach sees their own face here. An admin has no photo, so
              their initials. Either way something is always drawn, so the bar
              never changes height. */}
          <span className="topbar-user">
            <Avatar name={user.name} src={user.role === 'coach' ? myPhoto.small : null} size="md" />
            {user.name}
          </span>
          <button onClick={doLogout}>Log out</button>
        </nav>
      </div>
      <div className="container">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
